import { useEffect } from "react";
import type { PaymentGatewayProps } from "@/lib/payment-gateways";
import { Building2 } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function BankTransferForm({
  onReady,
  text,
}: PaymentGatewayProps) {
  const { t } = useTranslation("checkout");

  useEffect(() => {
    onReady(true);
  }, [onReady]);

  if (text && text.trim().length > 0) {
    return (
      <div className="space-y-2 py-1">
        <div
          className="text-sm text-muted-foreground leading-relaxed prose prose-sm dark:prose-invert max-w-none break-words [&>p]:mb-1 [&>p:last-child]:mb-0"
          dangerouslySetInnerHTML={{ __html: text }}
        />
      </div>
    );
  }

  return (
    <div className="space-y-2 py-1">
      <div className="flex items-center gap-2 text-sm font-medium text-primary">
        <Building2 className="h-4 w-4 shrink-0" />
        <span>{t("bankTransferTitle") || "Istruzioni per il bonifico"}</span>
      </div>
      <p className="text-sm text-muted-foreground leading-relaxed">
        {t("bankTransferDefaultInstructions") ||
          "Riceverai via email le coordinate bancarie (IBAN e causale) e le istruzioni dettagliate per effettuare il bonifico. La prenotazione sarà confermata a ricezione del pagamento o dell'invio della contabile."}
      </p>
    </div>
  );
}
